import { Box, Heading } from "grommet";
import colors from "../colors";

const PageHeader = ({label}) => {
  return (
    <Box
      background={"linear-gradient("+colors.dark+" -50%, "+colors.light+" 100%);"}
      round={{ size: "full", corner: "bottom" }}
      height={'xsmall'}
      justify="center"
    >
      <Heading alignSelf="center" size="small"><i>{label}</i></Heading>
    </Box>
  );
};
export default PageHeader;
